module.exports = __webpack_public_path__ + "img/about-disabled.e687bba1.svg";